import { EligibilityInfo } from 'components/esg-eligibility/esg-eligibility-info';
import { FormattedMessage } from 'react-intl';

export function EsgEquityEligibilityCol() {
  return (
    <div className="flex-x flex-wrap" style={{ gap: '0px 8px' }}>
      <FormattedMessage id="underlyingUniverse.grid.column.esgEligibility" />
      <EligibilityInfo />
    </div>
  );
}
